import { useQuery, useQueryClient,useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { fetchTeamMember, createTeamMember, updateTeamMember, deleteTeamMember } from "../api/boardApi";
import { useEffect } from "react";
export const useTeamMember = () =>{
    const queryClient = useQueryClient();
    const { data: teamMembers, error, isLoading } = useQuery({
        queryKey: ["teamMembers"],
        queryFn: fetchTeamMember,
    });

    const createTeamMemberMutation = useMutation({
        mutationFn: createTeamMember,
        onSuccess: (data) => {
            toast.success(data.message || "Add member successfully!");
            queryClient.invalidateQueries(["teamMembers"]);
        },
        onError: (error) => {
            toast.error(error.response?.data.message || "Failed to add member!");
        },
    });

    const updateTeamMemberMutation = useMutation({
        mutationFn: updateTeamMember,
        onSuccess: (data) => {
            toast.success(data.message || "Updated successfully!");
            queryClient.invalidateQueries(["teamMembers"]);
        },
        onError: (error) => {
            toast.error(error.response?.data.message || "Failed to update!");
        },
    });

    const deleteTeamMemberMutation = useMutation({
        mutationFn: deleteTeamMember,
        onSuccess: (data) => {
            toast.success(data.message || "Delete member successfully!");
            queryClient.invalidateQueries(["teamMembers"]);
        },
        onError: (error) => {
            toast.error(error.response?.data.message || "Failed to delete member!");
        },
    });

    useEffect(() => {
        if (error) {
            toast.error(error.response?.data?.message || "Failed to fetch Team Members");
        }
    }, [error]);

    return {
        teamMembers,
        isLoading,
        createTeamMemberMutation,
        updateTeamMemberMutation,
        deleteTeamMemberMutation,
    };
}